import { compose, filter, identity, map, pick, sum, values } from 'ramda'
import { useFilter } from '@btime/react-contexts'
import React from 'react'

import ChecklistsFilter from '../../../../containers/checklists/filters/ChecklistsFilter'
import FilterLink from '../../../../components/filter/FilterLink'
import FilterSideModal from '../../../../components/filter/FilterSideModal'
import PlacesFilter from '../../../../containers/places/filters/PlacesFilter'
import ServiceOrdersFilter from '../../../../containers/serviceOrders/filters/ServiceOrdersFilter'
import UsersFilter from '../../../../containers/users/filters/UsersFilter'

const EntitiesFilter = ({ label, field, icon, full, presentation, ...props }) => {
  const [open, setOpen] = React.useState(false)

  const count = compose(
    sum,
    map(array => array.length),
    filter(identity),
    values,
    pick(['entityUserIds', 'entityChecklistIds', 'entityPlaceIds', 'entityServiceOrderIds'])
  )(useFilter())

  const selectedValue = count > 0 && `${count} entitade(s)`

  return (
    <>
      <FilterLink icon="RiCalendarEventFill" label="Entidades" value={selectedValue} onClick={() => setOpen(true)} />

      <FilterSideModal
        open={open}
        onClose={() => setOpen(false)}
        label="Entidades"
        renderOptions={() => (
          <>
            <UsersFilter field="entityUserIds" presentation="list" />
            <ServiceOrdersFilter label="Atividade" field="entityServiceOrderIds" presentation="list" />
            <ChecklistsFilter label="Questionários" field="entityChecklistIds" presentation="list" />
            <PlacesFilter label="Locais" type="location" field="entityPlaceIds" presentation="list" />
            <PlacesFilter label="Pessoas" type="person" field="entityPlaceIds" presentation="list" />
            <PlacesFilter label="Frotas" type="fleet" field="entityPlaceIds" presentation="list" />
          </>
        )}
      />
    </>
  )
}

export default EntitiesFilter
